import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { LineChart } from '@mui/x-charts'
import styles from '../SuperAdminDashboard.module.scss'

export function AdminPlannedWeddingsChartCard() {
	const plannedWeddingsByWeekSeries = useSelector(
		(s) => s.admin.plannedWeddingsByWeekSeries
	)
	const plannedWeddingsByWeekChartLoading = useSelector(
		(s) => s.admin.plannedWeddingsByWeekChartLoading
	)
	const plannedWeddingsByWeekChartError = useSelector(
		(s) => s.admin.plannedWeddingsByWeekChartError
	)

	const plannedDataset = useMemo(() => {
		if (!Array.isArray(plannedWeddingsByWeekSeries)) return []
		return plannedWeddingsByWeekSeries.map((r) => ({
			week: r.weekStart,
			count: r.count,
		}))
	}, [plannedWeddingsByWeekSeries])

	return (
		<div className={styles.chartCard}>
			<h2 className={styles.chartCardTitle}>Planned weddings by week</h2>
			<p className={styles.chartCaption}>
				From today onward (UTC), by wedding startDate week.
			</p>
			{plannedWeddingsByWeekChartLoading ? (
				<p className={styles.chartPlaceholder}>Loading…</p>
			) : plannedWeddingsByWeekChartError ? (
				<p className={styles.statsErrorInline}>
					{plannedWeddingsByWeekChartError}
				</p>
			) : plannedDataset.length === 0 ? (
				<p className={styles.chartPlaceholder}>No data</p>
			) : (
				<Box className={styles.chartInner}>
					<LineChart
						dataset={plannedDataset}
						xAxis={[
							{
								dataKey: 'week',
								scaleType: 'point',
								label: 'Week (UTC start)',
							},
						]}
						series={[
							{
								dataKey: 'count',
								label: 'Weddings',
								curve: 'monotone',
								showMark: true,
								color: '#5a8aa3',
							},
						]}
						grid={{ horizontal: true, vertical: false }}
						margin={{
							top: 48,
							right: 12,
							bottom: 48,
							left: 48,
						}}
						height={320}
						slotProps={{
							legend: { hidden: true },
						}}
					/>
				</Box>
			)}
		</div>
	)
}
